// extracted by mini-css-extract-plugin
module.exports = {"banner_placeholder":"ystRv","banner_placeholder_nobg":"Gzw4h"};